import { parseApplicantEmployment } from "components/Application/Form/ApplicantEmployment/api";
import { FormSchemaApplicantDetails } from "../ApplicantDetails/types";
import { FormSchemaApplicantEmployment } from "./types";

const parseDataForApi = (
  data: Array<FormSchemaApplicantEmployment>,
  _numberOfApplicants: number,
  applicantsFieldArray: Array<FormSchemaApplicantDetails>,
) => {
  if (!data) {
    return data;
  }

  const applicantsDetail = Object.values(data).map((applicant, i) => {
    parseApplicantEmployment(applicant);
    if (!applicant.applicantId) {
      applicant.applicantId = applicantsFieldArray[i].uuid;
    }
    return applicant;
  });

  return applicantsDetail;
};

export default parseDataForApi;
